import { useMutation } from "react-query";
import { useDispatch } from "react-redux";

import { SuccessMsgUpdate } from "globalConstants";
import { getErrorMessage } from "helpers";
import { allMerchantService } from "services";
import { uiActions } from "store";
import { ErrorResponse } from "types";

type UseUnClaimCreditReviewMutationProps = {
	id: number;
	onSuccessHandler?: Function;
};

const useUnClaimCreditReviewMutation = ({ onSuccessHandler }) => {
	const dispatch = useDispatch();

	return useMutation(
		({ id }: UseUnClaimCreditReviewMutationProps) => {
			dispatch(uiActions.showSpinnerOverlay());

			return allMerchantService.unClaimMerchant({
				id,
			});
		},
		{
			onSettled() {
				dispatch(uiActions.hideSpinnerOverlay());
			},
			onSuccess() {
				dispatch(
					uiActions.showSuccessNotification({
						title: `Assignee ${SuccessMsgUpdate}`,
					}),
				);
				onSuccessHandler?.();
			},
			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: getErrorMessage(error),
					}),
				);
			},
		},
	);
};

export default useUnClaimCreditReviewMutation;
